var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerCombustionUnitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#000000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000, 25.000) scale(0.025000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360-180q-125.62 0-212.81-87.17T60-479.94q0-125.6 87.19-212.83Q234.38-780 360-780h240q125.62 0 212.81 87.17T900-480.06q0 125.6-87.19 212.83Q725.62-180 600-180H360Zm0-60h240q100 0 170-70t70-170q0-100-70-170t-170-70H360q-100 0-170 70t-70 170q0 100 70 170t170 70Zm120-170q29.15 0 49.58-20.42Q550-450.85 550-480t-20.42-49.58Q509.15-550 480-550t-49.58 20.42Q410-509.15 410-480t20.42 49.58Q450.85-410 480-410Zm-70-200h140v-60H410v60Zm0 320h140v-60H410v60Zm200-120h60v-140h-60v140Zm-320 0h60v-140h-60v140Zm190-70Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerCombustionUnitIcon);
export default __webpack_public_path__ + "static/media/marker-combustionUnit-icon.2a36c1537527c1afe0e820e9ca4895f9.svg";
export { ForwardRef as ReactComponent };